/* 
 * 接口统一集成模块
 */
import * as newsCenter from './moudules/newsCenter' //获取资讯中心

// 默认全部导出
export default {
    newsCenter
}